<template>
    <div class="document-upload__container">
        <div class="document-upload__wrapper">
            <GenericForm
                #default="slotProps"
                :asyncErrors="asyncErrors"
                :fields="fields"
                @submit="onSubmit"
            >
                <div class="instruction">
                    {{ $t(uploadInstruction) }}
                </div>
                <div class="form-content">
                    <CustomFileInput
                        v-model="fields.file.value"
                        :dropAreaLabel="'drag and drop the image here'"
                        name="file"
                        :errorMessage="slotProps.errors.file"
                        @valueChanged="onChange($event, slotProps.onValueChanged)"
                        accept="image/*, application/pdf"
                    />
                </div>
                <div class="upload-footer">
                    <div class="file-size-warning">
                        {{ $capitalize($t('file size is limited to').toString()) }}
                        <span class="max-size">
                            {{ fileSizeHumanReadable }}.
                        </span>
                        {{ $capitalize($t('only images are allowed').toString()) }}!
                    </div>
                    <div
                        class="action-text"
                        @click="showHelp"
                    >
                        {{ $capitalize($t('help').toString()) }}
                    </div>
                </div>
                <div
                    v-if="error"
                    class="message message--error-big"
                >
                    {{ $capitalize($t('Something went wrong. Please try again').toString()) }}
                </div>
                <CustomButton
                    :isLoading="isLoading"
                    :disabled="isUploadDisabled"
                    theme="primary"
                    size="lg"
                    isBlockButton
                    type="submit"
                >
                    <template v-if="error">
                        {{ $capitalize($t('retry').toString()) }}
                    </template>
                    <template v-else>
                        {{ $t('submit for verification').toUpperCase() }}
                    </template>
                </CustomButton>
            </GenericForm>
        </div>
    </div>
</template>

<script>
    import {
        getConfig,
        DocumentType,
    } from '@superbet-group/web.lib.config';
    import { mapActions } from 'vuex';

    import DocumentUploadMixin from '@accountCountries/registration/mixins/DocumentUploadMixin';
    import {
        maxFileSize,
        allowedFormatsByFilename,
    } from '@modules/shared/validators/forms';
    import { Analytics as AnalyticsSDK } from '@superbet-group/web.analytics.sdk';
    import { isRequired } from '@superbet-group/web.lib.utilities';

    export default {
        mixins: [DocumentUploadMixin],
        props: {
            uploadInstruction: {
                type: String,
                default: 'documentUploadInstruction',
            },
            fileSize: {
                type: Number,
                required: true,
            },
            fileSizeHumanReadable: {
                type: String,
                required: true,
            },
            isUploadDisabled: {
                type: Boolean,
                default: false,
                required: false,
            },
            documentTypeSelected: {
                type: String,
                default: DocumentType.Unknown,
                required: false,
            },
            username: {
                type: String,
                default: null,
                required: false,
            },
            usernameHash: {
                type: String,
                default: null,
                required: false,
            },
            otc: {
                type: String,
                default: null,
                required: false,
            },
        },
        data() {
            return {
                isLoading: false,
                error: '',
                asyncErrors: {},
                fields: {
                    file: {
                        value: null,
                        validate: [
                            isRequired,
                            maxFileSize(
                                this.fileSize,
                                this.fileSizeHumanReadable,
                            ),
                            allowedFormatsByFilename(getConfig().app.user.idCardVerification.allowedFormats),
                        ],
                    },
                },
            };
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            onChange(event, onValueChanged) {
                onValueChanged(event, 'file');
                const isAccountReopenKycRequired = this.username && this.otc;
                if (isAccountReopenKycRequired) {
                    AnalyticsSDK.getInstance().log('Reopen_Account_KYC_Choose_File', {
                        eventLabel: 'kyc_required',
                        usernameHash: this.usernameHash,
                    });
                }
            },
        },
    };
</script>
